import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/siders").GET();

export const SiderSchema = endpoint.res.shape.siders.unwrap().element;
export type WaSider = z.infer<typeof SiderSchema>;

export type SidersQuery = typeof endpoint.types.Q;

export async function getSiders(
    {
        taskId,
        query,
    }: {
        taskId: typeof endpoint.types.P.id;
        query: typeof endpoint.types.Q;
    },
    signal?: AbortSignal,
) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));

    return await call({
        params: {
            id: taskId,
        },
        query: query,
        signal,
    });
}
